// redux/actions/usuarios/types.js
export const FETCH_USUARIOS_SUCCESS = "FETCH_USUARIOS_SUCCESS";
export const FETCH_USUARIOS_FAILURE = "FETCH_USUARIOS_FAILURE";
